// extracted by mini-css-extract-plugin
export var cardHeader = "_tz-0";
export var reorderHandle = "_tz-3";
export var titleArea = "_tz-1";
export var titleAreaWithHandle = "_tz-2";